function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M2 9.2C2 6.67976 2 5.41965 2.49047 4.45704C2.9219 3.61031 3.61031 2.9219 4.45704 2.49047C5.41965 2 6.67976 2 9.2 2H14.8C17.3202 2 18.5804 2 19.543 2.49047C20.3897 2.9219 21.0781 3.61031 21.5095 4.45704C22 5.41965 22 6.67976 22 9.2V14.8C22 17.3202 22 18.5804 21.5095 19.543C21.0781 20.3897 20.3897 21.0781 19.543 21.5095C18.5804 22 17.3202 22 14.8 22H9.2C6.67976 22 5.41965 22 4.45704 21.5095C3.61031 21.0781 2.9219 20.3897 2.49047 19.543C2 18.5804 2 17.3202 2 14.8V9.2Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 2H9.5V3C9.5 3.55228 9.05228 4 8.5 4C7.94772 4 7.5 3.55228 7.5 3V2.00816C6.05569 2.03197 5.17387 2.12523 4.45704 2.49047C3.61032 2.9219 2.9219 3.61031 2.49047 4.45704C2.27264 4.88457 2.15155 5.37077 2.08424 6H21.9158C21.8485 5.37077 21.7274 4.88457 21.5095 4.45704C21.0781 3.61031 20.3897 2.9219 19.543 2.49047C18.8261 2.12523 17.9443 2.03197 16.5 2.00816V3C16.5 3.55228 16.0523 4 15.5 4C14.9477 4 14.5 3.55228 14.5 3V2Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }));
};
export default SvgCalendar;